<template>

  <div class="container pt-4 pb-4">

    <div>

      <b-row align-v="center">

        <b-col lg="12">

          <div class="mt-4">

            <div class="mt-3">

              <label>
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  text_snippet
                </span> 
                Wybierz efekt z listy:
              </label>

              <b-input-group>

                <b-form-select v-model="style" ref="style" size="lg" :options="styles"></b-form-select>

              </b-input-group>

 
              <label class="mt-3">
                <span class="material-symbols-outlined align-middle text-primary fw-200">
                  image
                </span> 
                Dodaj zdjęcie
              </label>

              <b-input-group>

                <b-form-file type="file" accept="image/*" @change="onFileChange" size="lg" ref="file" placeholder="Wybierz plik..." browse-text="Wybierz plik"></b-form-file>

              </b-input-group>
 
            </div>

          </div>

        </b-col>

      </b-row>

      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">

        </b-col>

        <b-col lg="6">

          <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
            Generuj grafikę
          </b-button>

        </b-col>

      </b-row>

 
      <div class="mt-2" >

        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje grafikę <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Proszę czekać...</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" style="font-size: 1em;">

            <img ref="outputImg" style="width:100%;height:auto;" src="" />

          </blockquote>

        </b-card>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'AppGraphicAi',
  components: {
  },
  data() {
    return {
      isFinish: false,
      result: "",
      generatedImg: false,
      imageBase64: null,
      imageBase64_2: null,
      selectedText: '',
      query: "",
      finishContent: '',
      selectedSchema: null,
      style: "Dym subtelny",
      styles: [
        "Dym subtelny",
        "Dym gęsty",
        "Dym kolorowy",
        "Mgła poranna",
        "Mgła filmowa",
        "Mgła dolna",
        "Para wodna",
        "Para gorąca",
        "Piorun",
        "Błyskawica",
        "Rozbryzgi wody",
        "Krople wody w powietrzu",
        "Deszcz realistyczny",
        "Deszcz neonowy",
        "Śnieg delikatny",
        "Śnieg burzowy",
        "Iskry ognia",
        "Żarzące się iskry",
        "Płomienie ognia",
        "Ogień kinowy",
        "Kurz w powietrzu",
        "Pył świetlny",
        "Bokeh klasyczny",
        "Bokeh kolorowy",
        "Bokeh serca",
        "Rozmycie ruchu",
        "Motion blur dynamiczny",
        "Smugi światła",
        "Smugi neonowe",
        "Lasery czerwone",
        "Lasery niebieskie",
        "Lasery wielokolorowe",
        "Promienie słońca",
        "Light leaks analogowe",
        "Light leaks retro",
        "Flary obiektywu",
        "Flary filmowe",
        "Poświata soft glow",
        "Poświata neon glow",
        "Halo światła",
        "Efekt bloom",
        "Efekt HDR",
        "Ziarnistość filmowa",
        "Grain analogowy",
        "Szum cyfrowy",
        "Efekt VHS",
        "Efekt glitch",
        "Rozdarcie obrazu",
        "Przesunięcie RGB",
        "Aberracja chromatyczna",
        "Efekt 3D anaglif",
        "Efekt hologramu",
        "Neonowe kontury",
        "Świetlne linie",
        "Świetlne cząsteczki",
        "Magiczne iskierki",
        "Efekt magiczny fantasy",
        "Aura energetyczna",
        "Energia elektryczna",
        "Błyskawice",
        "Prąd elektryczny",
        "Plasma light",
        "Tło galaktyczne",
        "Pył kosmiczny",
        "Gwiezdne drobiny",
        "Efekt space glow",
        "Efekt cyberpunk",
        "Efekt vaporwave",
        "Efekt synthwave",
        "Kolorowe gradienty",
        "Gradienty neonowe",
        "Gradienty pastelowe",
        "Efekt duotone",
        "Efekt monochromatyczny",
        "Efekt sepia",
        "Efekt vintage",
        "Efekt retro film",
        "Efekt low key",
        "Efekt high key",
        "Winieta",
        "Winieta filmowa",
        "Cienie dramatyczne",
        "Podwójna ekspozycja",
        "Nakładka tekstury papieru",
        "Nakładka betonu",
        "Nakładka pęknięć",
        "Efekt mokrej szyby",
        "Odbicia świetlne",
        "Refleksy szkła",
        "Efekt lustra",
        "Efekt rozmycia radialnego",
        "Efekt tilt shift",
        "Efekt makiety",
        "Efekt miniatury",
        "Efekt dymnych smug",
        "Efekt pastelowego światła",
        "Efekt złotej godziny",
        "Efekt niebieskiej godziny",
        "Efekt cinematic look",
        "Efekt editorial fashion",
        "Efekt instagramowy",
        "Efekt AI surreal"

      ]
    }
  },
  methods: {

    onFileChange (event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        this.imageBase64 = e.target.result.split(',')[1]
        // albo jeśli chcesz tylko czysty base64:
        // this.imageBase64 = e.target.result.split(',')[1]
      }

      reader.readAsDataURL(file)
    },

    
    onFileChange2 (event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()

      reader.onload = (e) => {
        this.imageBase64_2 = e.target.result.split(',')[1]
        // albo jeśli chcesz tylko czysty base64:
        // this.imageBase64 = e.target.result.split(',')[1]
      }

      reader.readAsDataURL(file)
    },

    generateFinish: function() {

      if(!this.style) return false;

      this.$refs.generatePost.disabled = true

      this.isFinish = true

      this.finishContent = ""
      this.result = ""
      
      var prompt = "Udekoruj to wnętrze w stylu " + this.style + "."
      
      this.axios.post(window.API_URL + "apps/graphicAi/paintnb/", { 'prompt': prompt, 'imageBase64': this.imageBase64  }, { withCredentials: true, timeout: 60000 }).then((response2) => {

          let data = response2.data

          this.finishContent = true;

          this.$refs.outputImg.src = "data:image/jpeg;charset=utf-8;base64," + data.base64;

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana grafika"


        }).catch(function() {

          this.$refs.generatePost.disabled = false

        });



    }

  },
  computed: {

  },
  created() {

    

  }

}
</script>

<style>

.pointer { cursor: pointer; }
.bold { font-weight: 600 !important; }
code { color: #4e82f7 !important; }
</style>